var map = {
	"./LI-Logo.png": 475,
	"./cp_home.jpg": 537,
	"./cp_recipe.jpg": 704,
	"./cp_top10.jpg": 742,
	"./cube_scrambled.jpg": 32,
	"./cube_solved.jpg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 727;